var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplyArrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80751 10.616L0.499512 5.308L5.80751 0L6.52051 0.708L1.92051 5.308L6.52051 9.908L5.80751 10.616ZM17.4995 12.308V9.308C17.4995 8.34667 17.1565 7.523 16.4705 6.837C15.7845 6.151 14.9608 5.808 13.9995 5.808H6.53651L10.6365 9.908L9.92251 10.616L4.61551 5.308L9.92251 0L10.6365 0.708L6.53651 4.808H13.9995C15.2422 4.808 16.3028 5.24733 17.1815 6.126C18.0602 7.00467 18.4995 8.06533 18.4995 9.308V12.308H17.4995Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyArrow2);
export default __webpack_public_path__ + "static/media/reply-arrow-2.0b66453189e7fbce5a8b4c13b2ca5df0.svg";
export { ForwardRef as ReactComponent };